import React from 'react';
import { Helmet } from 'react-helmet-async';
import './ReturnPolicy.css';

function ReturnPolicy() {
  return (
    <div className="return-policy-section">
      <Helmet>
        <title>Return & Refund Policy | Szakacs Visuals Photography</title>
        <meta name="description" content="Return and refund policy for Szakacs Visuals photography services. Learn about our cancellation, rescheduling, and refund policies." />
        <meta name="keywords" content="photography refund policy, photography cancellation policy, Bristol photographer returns, photography service refunds" />
        <meta property="og:title" content="Return & Refund Policy | Szakacs Visuals Photography" />
        <meta property="og:description" content="Return and refund policy for Szakacs Visuals photography services. Learn about our cancellation, rescheduling, and refund policies." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://szakacsvisuals.co.uk/returns" />
        <link rel="canonical" href="https://szakacsvisuals.co.uk/returns" />
      </Helmet>
      <div className="return-container">
        <h1>Return Policy</h1>
        <div className="return-content">
          <div className="business-info">
            <p>Business Name: Szakacs Visuals</p>
          </div>

          <section>
            <p>Thank you for shopping with us! Please note the following regarding our return policy:</p>
          </section>

          <section>
            <h2>Digital Products</h2>
            <p>All digital products are non-refundable. Once purchased, they will be sent directly to your email address. Please ensure the accuracy of your email before completing the purchase.</p>
          </section>

          <section>
            <h2>Booking Deposits</h2>
            <p>Any booking deposits made are non-refundable. Please be sure to confirm your reservation details before submitting payment.</p>
          </section>

          <section>
            <p>We appreciate your understanding. If you have any questions or concerns, please don't hesitate to contact us.</p>
          </section>

          <div className="contact-info">
            <p>Email: szakacs.visuals@gmail.com</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReturnPolicy; 